/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum DevicesReplaceActionAliases {
  AUTOC_ACTION_INSTALL = 'autoc-action-install',
  AUTOC_ACTION_REMOVE = 'autoc-action-remove',
  AUTOC_CALIBER = 'autoc-caliber',
  AUTOC_REASON_WITHDWAWN = 'autoc-reason-withdwawn',
  AUTOC_SIDE = 'autoc-side',
  AUTOC_TOPOGRAPHY = 'autoc-topography',
  CONTEXTUAL_BAR_REPLACE_ACTION_MENU = 'contextual-bar-replace-action-menu',
  DYNAMIC_FIELDS = 'dynamic-fields',
  FETCH_ACTION_INSTALL = 'fetch-action-install',
  FETCH_ACTION_REMOVE = 'fetch-action-remove',
  FETCH_ACTION_TOPOGRAPHY = 'fetch-action-topography',
  FETCH_CALIBER = 'fetch-caliber',
  FETCH_REASON_WITHDWAWN = 'fetch-reason-withdwawn',
  FETCH_SIDE = 'fetch-side',
  FIELD_ACTION_INSTALL = 'field-action-install',
  FIELD_ACTION_REMOVE = 'field-action-remove',
  FIELD_CALIBER = 'field-caliber',
  FIELD_DATE = 'field-date',
  FIELD_DEVICE = 'field-device',
  FIELD_REASON_WITHDWAWN = 'field-reason-withdwawn',
  FIELD_RETIRADA_PREVISTA = 'field-retirada-prevista',
  FIELD_SIDE = 'field-side',
  FIELD_TOPOGRAPHY = 'field-topography',
  FIELDSET_DYNAMIC_FIELDS = 'fieldset-dynamic-fields',
  FORM_DEVICES_REPLACE_ACTION_VIEWER = 'form-devices-replace-action-viewer',
  INFORMATION_BAR_HEADER_FRAGMENT = 'information-bar-header-fragment',
  INPUT_DATE = 'input-date',
  INPUT_RETIRADA_PREVISTA = 'input-retirada-prevista',
  LAYOUT_DEVICES_REPLACE_ACTION = 'layout-devices-replace-action',
  MAPPER_ACTION_INSTALL = 'mapper-action-install',
  MAPPER_ACTION_REMOVE = 'mapper-action-remove',
  MAPPER_CALIBER = 'mapper-caliber',
  MAPPER_REASON_WITHDWAWN = 'mapper-reason-withdwawn',
  MAPPER_SIDE = 'mapper-side',
  MAPPER_TOPOGRAPHY = 'mapper-topography',
  PANEL_HEADER = 'panel-header',
  TEXT_ACTION_INSTALL = 'text-action-install',
  TEXT_ACTION_REMOVE = 'text-action-remove',
  TEXT_CALIBER = 'text-caliber',
  TEXT_DEVICE = 'text-device',
  TEXT_REASON_WITHDWAWN = 'text-reason-withdwawn',
  TEXT_SIDE = 'text-side',
  TEXT_TOPOGRAPHY = 'text-topography',
}
export { DevicesReplaceActionAliases };
